import {library} from '@fortawesome/fontawesome-svg-core'

import {
  faSearch,
  faCheckSquare,
  faSquare,
  faUpload,
  faEdit,
  faPencilAlt,
  faLink,
  faTrash,
  faAngleDown,
  faExchangeAlt,
  faToggleOn,
  faToggleOff,
  faTrashAlt,
  faDownload,
  faExclamationTriangle,
  faSignOutAlt,
  faUserCircle,
  faTv,
  faProjectDiagram,
  faInfo,
  faExternalLinkAlt,
  faChevronLeft,
  faChevronRight,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

import {
  faQuestionCircle,
  faListAlt,
  faFileCode,
} from '@fortawesome/free-regular-svg-icons';

// Configures a FontAwesome icon library.
// See https://github.com/FortAwesome/react-fontawesome#usage
library.add(
  faSearch,
  faCheckSquare,
  faSquare,
  faQuestionCircle,
  faListAlt,
  faUpload,
  faEdit,
  faPencilAlt,
  faLink,
  faTrash,
  faAngleDown,
  faExchangeAlt,
  faToggleOn,
  faToggleOff,
  faTrashAlt,
  faDownload,
  faFileCode,
  faExclamationTriangle,
  faSignOutAlt,
  faUserCircle,
  faTv,
  faProjectDiagram,
  faInfo,
  faExternalLinkAlt,
  faChevronLeft,
  faChevronRight,
  faTimes
);
